import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { useReportsQuery } from "modules/FactoryExportsDashboard/hooks";
import { FactoryExportsDashboardQueryKeys } from "modules/FactoryExportsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";
import { toISOString } from "utils/dateHelperFunctions";

import type { FACTORYEXPORT_FREQUENCY, FACTORYEXPORT_QUERYRANGE, FACTORY_REPORTS, FactoryExport, FactoryExportID } from "models";

type AddExportResponse = {
  factory_export_id: FactoryExportID;
};

export type FactoryExportFormPayload = Pick<
  FactoryExport,
  "name" | "emails" | "email_subject" | "email_message" | "is_ams_timezone" | "is_ods_format" | "dealer_ids" | "dealer_location_ids" | "brand_group_ids"
> & {
  id: FactoryExportID | null;
  day: number | null;
  frequency: FACTORYEXPORT_FREQUENCY | null;
  query_range: FACTORYEXPORT_QUERYRANGE | null;
  factory_report_id: FACTORY_REPORTS | null;
};

export type FactoryExportPayload = Omit<FactoryExportFormPayload, "day" | "frequency" | "query_range" | "factory_report_id"> &
  Pick<FactoryExport, "day" | "frequency" | "query_range" | "factory_report_id">;

export const useAddExportMutation = () => {
  const { data: reports = [] } = useReportsQuery();

  return useTypedMutation<FactoryExportPayload, AddExportResponse>({
    mutationFn: async payload => (await ApiInstance.post("/exports/create", payload, ENV.reportsBaseURL)).data,
    onSuccess: (payload, { factory_export_id }) => {
      const exports = typedQueryClient.getQueryData(FactoryExportsDashboardQueryKeys.exports);
      const now = toISOString(new Date());

      typedQueryClient.setQueryData(FactoryExportsDashboardQueryKeys.exports, [
        ...(exports ?? []),
        {
          ...payload,
          id: factory_export_id,
          created_on: now,
          updated_on: now,
          factory_report_name: reports.find(report => report.value === payload.factory_report_id)?.text ?? ""
        }
      ]);
    }
  });
};
